//Props Validations
import PropTypes from "prop-types";

import DriverAnalysisCategory from "./DriverAnalysisCategory";

function DriverAnalysisMacroCategory({ data = [] }) {
    return (
        <>
            <div style={{ marginTop: "26px" }}>
                <div
                    style={{
                        display: "grid",
                        gridTemplateColumns: "20% 20% 20% 20% 20%",
                    }}
                >
                    {data && data.length !== 0 ? (
                        data
                            .sort((a, b) => {
                                return b.value - a.value;
                            })
                            .map((datum, index) => {
                                if (index < 5) {
                                    return (
                                        <DriverAnalysisCategory
                                            data={datum}
                                            index={index}
                                            key={index}
                                        />
                                    );
                                }
                            })
                    ) : (
                        <div>No Report found</div>
                    )}
                </div>
            </div>
        </>
    );
}

// Typechecking props for the DriverAnalysis
DriverAnalysisMacroCategory.propTypes = {
    data: PropTypes.array,
};

export default DriverAnalysisMacroCategory;
